var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7999 1.09961H5.19993C3.22006 1.09961 2.23012 1.09961 1.61503 1.71469C0.99994 2.32976 0.99994 3.31971 0.99994 5.29961V6.69961C0.99994 8.67949 0.99994 9.66943 1.61503 10.2845C2.23012 10.8996 3.22006 10.8996 5.19993 10.8996H10.7999",
    stroke: "#172B4D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 3.89844C13.3248 4.31133 15 5.41023 15 5.99844C15 6.58665 13.3248 7.68558 12.9 8.09844",
    stroke: "#172B4D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.89844C7.57524 4.31133 5.9 5.41023 5.9 5.99844C5.9 6.58665 7.57524 7.68558 8 8.09844",
    stroke: "#172B4D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H6.60001",
    stroke: "#172B4D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCost);
export default __webpack_public_path__ + "static/media/cost.a00fc4742a5d0a305623396441e76c90.svg";
export { ForwardRef as ReactComponent };